/* PartnerLinks: a band under a collection's cards — copy on the left, the
   partner buttons on the right from 768 px; stacked on phones. */
.band {
  display: grid;
  gap: 18px;
  margin-top: 34px;
  padding: 24px 22px;
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
  background: var(--band);
}

.copy {
  max-width: 720px;
}

.title {
  margin: 0 0 8px;
  font-family: var(--font-display);
  font-weight: 600;
  font-size: 22px;
  line-height: 1.15;
}

.text {
  margin: 0;
  font-size: 14px;
  line-height: 1.65;
  color: var(--text-secondary);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px 16px;
}

@media (min-width: 768px) {
  .band {
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: center;
    gap: 32px;
    padding: 28px 32px;
  }

  .title {
    font-size: 25px;
  }

  .text {
    font-size: 15px;
  }

  .actions {
    justify-content: flex-end;
  }
}
